'use client';

import { cn } from '@/lib/utils';
import parse from 'html-react-parser';
import SliderBase from './SliderBase';
import Url from './Url';

export default function Slider(Prop: {moduleOption: any}) {
  const options = Prop.moduleOption || {};
  // sliderSetting
  const sliderItems = options.items || [];
  const imageHeight = options?.height || 120;
  const isCustomTemplate = (options?.template ?? '') != '';

  const formTemplate = (sliderItem: any) => {
    let template = options.template ?? '';
    Object.entries(sliderItem).forEach(([key, value]) => {
      if (typeof value === 'string') {
        template = template.replaceAll(`{${key}}`, value);
      }
    });
    return parse(template);
  };
  return (
    <SliderBase
      options={options}
      template={(sliderItem: any) => {
        return (
          <Url href={sliderItem?.url || '#'} title={sliderItem.caption || ''}>
            {isCustomTemplate && formTemplate(sliderItem)}
            {!isCustomTemplate && (
              <div className="flex flex-col items-start justify-center hover:bg-[#f8f8f8] rounded-b-sm ">
                {sliderItem.image && (
                  <div className="w-full flex justify-center items-start">
                    <img
                      className={cn(
                        imageHeight < 0
                          ? 'object-contain w-full h-auto max-w-[100%]'
                          : 'object-cover object-center w-[100%]'
                      )}
                      src={sliderItem.image}
                      alt={`${sliderItem.caption || ''} image`}
                      style={{
                        ...(imageHeight > 0 ? {height: imageHeight + 'px'} : {})
                      }}
                    />
                  </div>
                )}

                {sliderItem.caption && (
                  <div
                    className={cn(
                      'h-[70px] px-4 lg:px-2 py-3 container flex items-start justify-center md:justify-start',
                      'questrial text-[13px] leading-relaxed font-500  overflow-hidden'
                    )}
                  >
                    <div className="line-clamp-2">{sliderItem.caption}</div>
                  </div>
                )}
              </div>
            )}
          </Url>
        );
      }}
      items={sliderItems}
    />
  );
}
